import React, { useContext, useEffect, useRef } from "react";

import { Preview, TextState } from "@creatomate/preview";

import VttText from "components/stories/video-studio/sidebar/tabs/subtitle/vtt/VttText";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import VttTime from "./VttTime";
import DeleteSection from "./DeleteSection";
import AddSection from "./AddSection";

interface VttSectionProps {
  index: number;
  preview: Preview;
  subtitleElement: TextState;
}

const VttSection: React.FC<VttSectionProps> = ({ preview, subtitleElement, index }) => {
  const vttContainerRef = useRef<HTMLDivElement>(null);
  const { getActiveElement } = useContext(CreatomateContext);

  useEffect(() => {
    const isActiveElement = () => {
      const activeElement = getActiveElement(preview);

      if (activeElement) {
        return activeElement.source.id === subtitleElement.source.id;
      }

      return false;
    };

    if (vttContainerRef.current && isActiveElement()) {
      vttContainerRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [getActiveElement, preview, subtitleElement.source.id]);

  return (
    <div className="VTT-Container__Section" ref={vttContainerRef}>
      <VttText
        preview={preview}
        subtitleElement={subtitleElement}
      />
      <VttTime
        index={index}
        preview={preview}
        subtitleElement={subtitleElement}
      />
      <div className="VTT-Container__Buttons">
        <DeleteSection preview={preview} subtitleElement={subtitleElement} />
        <AddSection preview={preview} subtitleElement={subtitleElement} />
      </div>
    </div>
  );
};

export default VttSection;
